/**
 * Tennis match format catalog (Casual Arena defaults).
 * ITF: best of 3 or 5 sets; games to 6 with 7-pt TB at 6–6;
 * optional Match Tiebreak (10-pt) for the deciding set.
 */

import { SPORT_IDS } from "../../../domain/sport/sportTypes";

/** @type {import("../../../domain/sport/sportMatchFormatCatalog").SportMatchFormatCatalog} */
export const TENNIS_MATCH_FORMAT = Object.freeze({
  sportId: SPORT_IDS.TENNIS,
  displayName: "Tennis",
  matchTypes: [
    { id: "singles", title: "Singles", sub: "1v1", matchType: "singles", playersPerSide: 1 },
    { id: "doubles", title: "Doubles", sub: "2v2", matchType: "doubles", playersPerSide: 2 },
  ],
  setsOptions: [
    { setsToWin: 2, title: "Best of 3" },
    { setsToWin: 3, title: "Best of 5" },
  ],
  pointsPresets: [
    { mode: 6, title: "Games to 6 (TB at 6–6)" },
    { mode: "custom", title: "Custom" },
  ],
  defaultSetsToWin: 2,
  defaultPointsToWin: 6,
  /** Engine: startMatch({ matchTiebreak: true }) — deciding set is 10-pt Match TB. */
  finalSetOptions: [
    { id: "standard", title: "Standard final set", matchTiebreak: false },
    {
      id: "match_tiebreak",
      title: "Match Tiebreak (10)",
      matchTiebreak: true,
      matchTiebreakTo: 10,
    },
  ],
  customPoints: {
    min: 4,
    max: 12,
    label: "Games to win set",
    placeholder: "6",
  },
  customSets: {
    min: 1,
    max: 5,
    label: "Custom best of",
    oddOnly: true,
  },
  pointsChipLabel: "Games",
  courtPresentationId: "tennis.court.v1",
  intervalPresentationId: "tennis.interval.v1",
  scoringSystem: "itf",
});
